import {Composition} from "./Composition";

export class Default extends Composition {
    static NAME = 'default';
}
